/* =====================================================================
   HP Facets — potenzia i filtri collezione/ricerca senza toccare il core:
   - conteggi "(N)" resi grigi
   - campo "Cerca per ..." nelle liste lunghe (filtro client-side)
   - "+ Mostra N altro" / "Mostra meno" per le liste lunghe
   Agisce SOLO sulla visibilita' delle <li>, mai sulle checkbox: il
   filtraggio Shopify/Alpine resta intatto.
   ===================================================================== */
(function () {
  if (window.__hpFacetsInit) return;
  window.__hpFacetsInit = true;

  var VISIBLE = 8;      // voci mostrate prima di "Mostra altro"
  var SEARCH_MIN = 10;  // da quante voci in su compare la ricerca (es. "Cerca per marchio")

  function titleOf(ul) {
    var el = ul;
    for (var i = 0; i < 6 && el; i++) {
      el = el.parentElement;
      if (!el) break;
      var btn = el.querySelector(':scope > button[aria-label]');
      if (btn) return (btn.getAttribute('aria-label') || '').replace(/\s*\(.*$/, '').trim();
    }
    return '';
  }

  function enhance(ul) {
    if (ul.__hpDone) return;
    var items = Array.prototype.slice.call(ul.children).filter(function (li) {
      return li.tagName === 'LI' && li.querySelector('input[type=checkbox]');
    });
    if (items.length < 2) return;
    ul.__hpDone = true;

    // 1) conteggi grigi
    items.forEach(function (li) {
      var span = li.querySelector('label span.p-break-words') || li.querySelector('label span');
      if (span && !span.__hpCount) {
        span.__hpCount = true;
        var m = span.textContent.match(/^([\s\S]*?)\s*\((\d[\d.]*)\)\s*$/);
        if (m) span.innerHTML = m[1].trim() + ' <span class="hp-facet-count">(' + m[2] + ')</span>';
      }
    });

    var expanded = false;
    var query = '';

    // funzione unica di visibilita'
    function refresh() {
      var q = query.toLowerCase();
      var shown = 0, idx = 0;
      items.forEach(function (li) {
        var val = (li.querySelector('input') && li.querySelector('input').value) || li.textContent;
        var matchSearch = !q || val.toLowerCase().indexOf(q) >= 0;
        var withinMore;
        if (q) {
          withinMore = true;                 // in ricerca: mostra tutti i match
        } else {
          withinMore = expanded || idx < VISIBLE;
        }
        var visible = matchSearch && withinMore;
        li.classList.toggle('hp-facet-hidden', !visible);
        if (matchSearch && !q) idx++;
        if (visible) shown++;
      });
      if (emptyEl) emptyEl.hidden = !(q && shown === 0);
      if (moreBtn) moreBtn.style.display = q ? 'none' : (items.length > VISIBLE ? '' : 'none');
    }

    // 2) ricerca (liste lunghe)
    var emptyEl = null;
    if (items.length >= SEARCH_MIN) {
      var t = titleOf(ul);
      var box = document.createElement('div');
      box.className = 'hp-facet-search';
      box.innerHTML =
        '<svg class="hp-facet-search__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
        '<input type="text" autocomplete="off" placeholder="Cerca per ' + (t || 'voce').toLowerCase() + '" aria-label="Cerca nei filtri">';
      ul.parentNode.insertBefore(box, ul);
      emptyEl = document.createElement('div');
      emptyEl.className = 'hp-facet-search__empty';
      emptyEl.hidden = true;
      emptyEl.textContent = 'Nessun risultato';
      ul.parentNode.insertBefore(emptyEl, ul.nextSibling);
      var inp = box.querySelector('input');
      inp.addEventListener('input', function () { query = inp.value.trim(); refresh(); });
    }

    // 3) mostra altro
    var moreBtn = null;
    if (items.length > VISIBLE) {
      var hidden = items.length - VISIBLE;
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'hp-facet-more';
      moreBtn.innerHTML =
        '<span class="hp-facet-more__label">+ Mostra ' + hidden + ' altro</span>' +
        '<svg class="hp-facet-more__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>';
      ul.parentNode.insertBefore(moreBtn, (emptyEl || ul).nextSibling);
      moreBtn.addEventListener('click', function () {
        expanded = !expanded;
        moreBtn.classList.toggle('is-open', expanded);
        moreBtn.querySelector('.hp-facet-more__label').textContent =
          expanded ? 'Mostra meno' : ('+ Mostra ' + hidden + ' altro');
        refresh();
      });
    }

    refresh();
  }

  function run() {
    document.querySelectorAll('.facets ul[role="list"]').forEach(enhance);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Alpine/AJAX rigenera i filtri al cambio: ri-applica (debounced)
  var host = document.querySelector('.facets');
  if (host && window.MutationObserver) {
    var tmr = null;
    new MutationObserver(function () {
      if (tmr) return;
      tmr = setTimeout(function () { tmr = null; run(); }, 120);
    }).observe(host, { childList: true, subtree: true });
  }
})();
